// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".styles-module__saveButton___Kuwvl {\n  width: 100%;\n}\n", "",{"version":3,"sources":["webpack://screens/business-profile-page/components/save-edits-button/styles.module.less"],"names":[],"mappings":"AAAA;EACE,WAAA;AACF","sourcesContent":[".saveButton {\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"saveButton": "styles-module__saveButton___Kuwvl"
};
export default ___CSS_LOADER_EXPORT___;
